import React from 'react'

const EmptyIcon = () => (
  <svg width="184" height="182" viewBox="0 0 184 182" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M128.892 176.45L156.025 22.5743L50.4044 3.9505L24.0897 22.1763L0.867472 153.876L128.892 176.45Z" fill="white"/>
    <path d="M46.7361 24.7546L50.4044 3.9505L24.3317 20.8041L46.7361 24.7546Z" fill="#F3F3F3"/>
    <path d="M104.994 131.773L110.356 136.273L106.957 137.99L103.818 138.619L103.893 135.418L104.994 131.773Z" fill="#97D3BD"/>
    <path d="M163.044 73.4401L157.722 68.9745C157.712 68.966 156.862 69.9588 155.686 71.3608L108.296 127.838C107.287 129.039 106.288 130.248 106.299 130.258L111.621 134.724C111.631 134.732 112.482 133.739 113.658 132.337L161.048 75.8603C162.224 74.4584 163.056 73.45 163.044 73.4401Z" fill="#3D77BC"/>
  </svg>
)

export default EmptyIcon
